import { connect } from 'react-redux'
import requestRemoveUserFromCard from '../../sagas/requestRemoveUserFromCard'
import requestAddLabelToCard from '../../sagas/requestAddLabelToCard'
import requestAddUserToCard from '../../sagas/requestAddUserToCard'
import requestChangeCardDueDate from '../../sagas/requestChangeCardDueDate'
import requestChangeCardName from '../../sagas/requestChangeCardName'
import requestChangeCardStartDate from '../../sagas/requestChangeCardStartDate'
import requestChangeCardStatus from '../../sagas/requestChangeCardStatus'
import requestRemoveCardDueDate from '../../sagas/requestRemoveCardDueDate'
import requestRemoveCardStartDate from '../../sagas/requestRemoveCardStartDate'
import requestRemoveLabelFromCard from '../../sagas/requestRemoveLabelFromCard'
import quickActionsSelector from './quickActionsSelector'
import QuickActions from './QuickActions'
import { withBoardContext } from 'dataProviders/Board'

export default withBoardContext(connect(
  quickActionsSelector,
  {
    requestChangeCardName,
    requestAddUserToCard,
    requestRemoveUserFromCard,
    requestChangeCardStatus,
    requestAddLabelToCard,
    requestRemoveLabelFromCard,
    requestChangeCardStartDate,
    requestRemoveCardStartDate,
    requestChangeCardDueDate,
    requestRemoveCardDueDate
  },
  null,
  {
    forwardRef: true
  }
)(QuickActions))
